import AutocompleteMagazzino from "../riutilizabili/autocomplite/AutocompliteMagazzino";
import AutocompliteProdotti from "../riutilizabili/autocomplite/AutocompliteProdotti";
import InputForm from "../riutilizabili/forms/InputForm";


const  FiltriGiacenze =({
    onChange ,
    values ,
    errors={}
}) => {

    const onChangeMagazzino = async ({ value, item }) => {
        onChange('magazzinoNome', item?.nome)
        onChange('magazzinoId', item?.id)
    }

    const onChangeProd = async ({ value, item }) => {

    }

    return(
        <div className="d-flex" >
            <InputForm
                label={'Data giacenza al'}
                type={'date'} 
                placeholder={'Inserisci giacenza al'}
                name={'dataFine'}
                value={values?.dataFine  || ''}
                onChange={(name , value) => onChange(name , value)}
                classi='col-2'
                errors={errors}
            />

            <div className="col-3 mt-3">
                <AutocompleteMagazzino 
                    value={values?.magazzinoNome || ''}
                    onChange={onChangeMagazzino}
                    label='Seleziona magazzino'
                    placeholder='inserisci magazzino'
                    className=' mb-0 '
                />
            </div>

            {/* <div className="col-6 mt-3 ms-3">
                <AutocompliteProdotti 
                    value={!!values?.descrizione ? values?.descrizione + ' - ' + values?.rifInterno : ''}
                    onChange={onChangeProd}
                    label='Seleziona Articolo'
                    placeholder='Selezione rapida : inserisci codice interno o descrizione articolo'
                    className=' mb-0 '
                />
            </div> */}

        </div>
    )
}

export default FiltriGiacenze